// ConfirmEmail.tsx
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getApiUrl } from "../../utils/getApiUrl";
import PageHeader from "../../components/pageHeader/pageHeader";

const ConfirmEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const token = searchParams.get("token");
  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Missing confirmation token.");
      return;
    }

    fetch(getApiUrl(`auth/confirm-email?token=${token}`))
      .then(async (resp) => {
        const data = await resp.json();
        if (resp.ok) {
          setStatus("success");
          setMessage("Your email has been confirmed! You can now log in.");
        } else {
          setStatus("error");
          setMessage(data.error || "Confirmation failed.");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Network error. Please try again.");
      });
  }, []);

  return (
    <>
      <div className="login-page-title">
        <PageHeader
          title="Dictionary"
          icon="bi-book"
        />
      </div>    
    
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
        <div className="text-center">
          {status === "loading" && <p>Confirming your email...</p>}
          {status === "success" && (
            <>
              <h3 className="text-success mb-3">✓ Email Confirmed</h3>
              <p>{message}</p>
              <button className="btn btn-success mt-2" onClick={() => navigate("/login")}>
                Go to Login
              </button>
            </>
          )}
          {status === "error" && (
            <>
              <h3 className="text-danger mb-3">Confirmation Failed</h3>
              <p>{message}</p>
              <button className="btn btn-danger mt-2" onClick={() => navigate("/")}>
                Back to Home
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ConfirmEmail;